import { getWindowName, WindowNameEnum } from './window';

export const isTeams = (): boolean => getWindowName() === WindowNameEnum.TEAMS;
